import { Stack, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import { useDateFormatter } from '../generic/hooks/useDateFormatter'

/**
* @typedef {import("../generic/utilities/objectStructures/planner/event").Event} Event Event object
**/

/**
 *
 * @param {object} props
 * @param {Event} props.event Current selected event
 * @param {React.Dispatch<React.SetStateAction<Event>>} props.setEvent Current selected event useState setter
 *
 * @returns
 */
const PartDateDialogContent = ({ event, setEvent }) => {
  const { t_ } = useSmartTranslation()
  const [config] = useFrontEndConfig()
  const { format } = useDateFormatter()

  return (
    <Stack gap={3} sx={{ marginTop: '1em' }}>
      {
      config?.plannerType === 'AIPLANNER'
        ? (
          <DatePicker
            label={t_('Minimun start date')}
            value={event && event.minDate !== null ? new Date(event.minDate) : ''}
            disabled={event ? !event.editable : false}
            onChange={(newValue) => {
              setEvent({ ...event, minDate: new Date(newValue) })
            }}
          // helperText={event && event.showErrorsTask && (event.date === null) ? "Value must not be null" : null}
            renderInput={(params) => <TextField {...params} />}
            format={format.date}
          />)
        : null
      }
      {/* Story 96 (RN38/D24, risk R4): qualified label. The bare "Priority" now belongs to the job's
          MOS queue priority in the "Job Settings" tab, and the two sit in sibling tabs of the same
          dialog -- reading the same would be the ambiguity the story exists to remove. The field
          itself is untouched: same `priority`, same 1..10 range, same validation (S81). */}
      <TextField
        label={t_('Part priority')}
        value={event ? event.priority : 5}
        disabled={event ? !event.editable : false}
        onChange={(newPriority) => setEvent({ ...event, priority: newPriority.target.value })}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        error={event && event.showErrorsTask && (isNaN(parseInt(event.priority)) || (parseInt(event.priority) < 1 || parseInt(event.priority) > 10))}
        helperText={event && event.showErrorsTask && (isNaN(parseInt(event.priority)) || (parseInt(event.priority) < 1 || parseInt(event.priority) > 10)) ? 'Value must be between 1 and 10' : null}
      />
    </Stack>
  )
}

export default PartDateDialogContent
